import {
  ExtractAtomicOperationFromDefinition,
  createAtomicOperationDefinition,
} from "../../atomic-operations";
import {
  AppSessionCellId,
  ExploreCellId,
  ExploreSpecSessionStateId,
} from "../../idTypeBrands";
import { SemanticCap } from "../../semanticCaps.js";
import { CREATE_APP_SESSION_CELL } from "../appSessionCellOperations";

import { ExploreSpecSessionStateUpdatableFields } from "./commonExploreSpecSessionStateTypes";

const CREATE_EXPLORE_SPEC_SESSION_STATE_TYPE =
  "CREATE_EXPLORE_SPEC_SESSION_STATE" as const;

export const CREATE_EXPLORE_SPEC_SESSION_STATE =
  createAtomicOperationDefinition({
    type: CREATE_EXPLORE_SPEC_SESSION_STATE_TYPE,
    readAuth: {
      kind: "and",
      and: [
        {
          kind: "hasSemanticCap",
          cap: SemanticCap.VIEW_APP_SESSION,
        },
        {
          kind: "hasSomeOfSemanticCapsOnIdArg",
          someOfCaps: [
            SemanticCap.VIEW_PROJECT_CONTENTS_FOR_APP,
            SemanticCap.VIEW_PROJECT_CONTENTS_FOR_LOGIC,
          ],
          idArg: "exploreCellId",
          idType: "ExploreCell",
        },
      ],
    },
    writeAuth: {
      kind: "and",
      and: [
        {
          kind: "hasSemanticCap",
          cap: SemanticCap.EDIT_APP_SESSION,
        },
        {
          kind: "hasSemanticCapOnIdArg",
          cap: SemanticCap.EDIT_APP_SESSION,
          idArg: "appSessionCellId",
          idType: "AppSessionCell",
        },
        {
          kind: "hasSomeOfSemanticCapsOnIdArg",
          someOfCaps: [
            SemanticCap.VIEW_PROJECT_CONTENTS_FOR_APP,
            SemanticCap.VIEW_PROJECT_CONTENTS_FOR_LOGIC,
          ],
          idArg: "exploreCellId",
          idType: "ExploreCell",
        },
        {
          kind: "idArgDoesNotExist",
          idArg: "exploreSpecSessionStateId",
          idType: "ExploreSpecSessionState",
        },
      ],
    },
    logSafe: [
      "exploreSpecSessionStateId",
      "exploreCellId",
      "appSessionCellId",
      "shouldRunCell",
    ],
    alwaysSkipUndoBuffer: true,
    conflictId: (op) =>
      `${CREATE_EXPLORE_SPEC_SESSION_STATE_TYPE}-${op.payload.exploreSpecSessionStateId}`,
    creationId: (op) =>
      `${CREATE_APP_SESSION_CELL.type}-${op.payload.appSessionCellId}`,
    create: (args: {
      exploreSpecSessionStateId: ExploreSpecSessionStateId;
      exploreCellId: ExploreCellId;
      appSessionCellId: AppSessionCellId;
      shouldRunCell?: boolean;
      options: Partial<ExploreSpecSessionStateUpdatableFields>;
    }) => ({
      type: CREATE_EXPLORE_SPEC_SESSION_STATE_TYPE,
      payload: {
        ...args,
      },
    }),
  });

export type CREATE_EXPLORE_SPEC_SESSION_STATE =
  ExtractAtomicOperationFromDefinition<
    typeof CREATE_EXPLORE_SPEC_SESSION_STATE
  >;
